<template>
  <div class="sidebar-bottom">
    <div class="help">
      <ul class="nav">
        <li class="nav-item">
          <a
            href="https://ta-mk2.helpscoutdocs.com/"
            target="_blank"
            class="nav-link"
          >
            <i class="fa fa-question-circle" /> Help
          </a>
        </li>
      </ul>
    </div>
    <button
      class="sidebar-minimizer"
      type="button"
      @click="sidebarMinimize();brandMinimize()"
    />
  </div>
</template>

<script setup lang="ts">
defineOptions({ name: 'SidebarMinimizer' })

function sidebarMinimize () {
  // Toggle on both body and .app container for CoreUI CSS compatibility
  document.body.classList.toggle('sidebar-minimized')
  document.querySelector('.app')?.classList.toggle('sidebar-minimized')
}

function brandMinimize () {
  document.body.classList.toggle('brand-minimized')
  document.querySelector('.app')?.classList.toggle('brand-minimized')
}
</script>
